// import third-party
import { useNavigate } from 'react-router-dom';
import { Box, Button, Flex, Spinner, Text } from '@chakra-ui/react';

// import third-local
import { ParagonIcon, ProductIcon } from '@assets/icons';
import { useConfirmModal } from '@store/useConfirmModal';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';
import { useMassalStore } from '../hooks/state/useAddProductMassal';
import useMutateUploadMapping from '../hooks/mutate/useMutateUploadMapping';

export default function PostUploadModal({ onCancel = () => {} }) {
    const { set, reset } = useFileUploadPopUp();
    const { data, resetMassal, setPieces, setBundles, setData } = useMassalStore();
    const { count_success, count_failed } = data;
    const { set: setConfirmModal } = useConfirmModal();
    const isLoading = false;

    const { confirmUploadProdukMassal } = useMutateUploadMapping();

    const navigate = useNavigate();

    const handleCancel = () => {
        onCancel();
        if (count_failed === 0) {
            set({ isOpen: false });
            return;
        }

        set({ isOpen: false });
        setConfirmModal({
            isOpen: true,
            title: 'Apakah kamu ingin batalkan mapping?',
            desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
            btnLabelYes: 'Ya, batal',
            onSubmit: () => {
                reset();
                resetMassal();
            },
            onClose: () => {
                set({ isOpen: true });
            },
        });
    };

    const handleContinue = () => {
        if (count_failed > 0) {
            set({ isOpen: false });

            const pieceProduct = data.failed_data.piece;
            setPieces(pieceProduct);

            const bundleProduct = data.failed_data.bundle;
            setBundles(bundleProduct);

            return navigate('/upload-mapping-v2/mapping-product');
        }

        const { success_data } = data;
        const payload = {
            ...success_data,
        };

        confirmUploadProdukMassal.mutate({ payload });
    };

    const handleClose = () => {
        set({ isOpen: false });
        navigate('upload-mapping-v2', { replace: true });
        setTimeout(() => {
            reset();
            resetMassal();
        }, 200);
    };

    return (
        <Box mt={'32px'}>
            <Box>
                <Flex gap={'16px'} justifyContent={'center'}>
                    <Flex gap={'31px'} p={'16px'} bg={'semantic.200'} borderRadius={'8px'}>
                        <Box>
                            <Text fontSize={'14px'} color={'neutral.600'} mb={'8px'}>
                                Kode Sesuai
                            </Text>
                            <Text fontSize={'20px'} fontWeight={'700'}>
                                {count_success} Produk
                            </Text>
                        </Box>

                        <Box bg={'paragon.100'} p={'8px'} borderRadius={'8px'} maxH={'fit-content'}>
                            <ParagonIcon />
                        </Box>
                    </Flex>

                    <Flex gap={'31px'} p={'16px'} bg={'semantic.200'} borderRadius={'8px'}>
                        <Box>
                            <Text fontSize={'14px'} color={'neutral.600'} mb={'8px'}>
                                Kode Berbeda
                            </Text>
                            <Text fontSize={'20px'} fontWeight={'700'}>
                                {count_failed} Produk
                            </Text>
                        </Box>

                        <Box bg={'warning.100'} p={'8px'} borderRadius={'8px'} maxH={'fit-content'}>
                            <ProductIcon color="#D1A400" />
                        </Box>
                    </Flex>
                </Flex>
            </Box>

            {count_failed > 0 ? (
                <Flex alignItems={'center'} flexDir={'column'} gap={'16px'} textAlign={'center'} my={'32px'}>
                    <Text color={'warning.600'} fontWeight={'700'} fontSize={'18px'} maxW={'430px'}>
                        {count_failed} Kode Produk Tidak Sesuai dengan Barcode Produk Paragon
                    </Text>
                    <Text fontSize={'14px'} maxW={'430px'}>
                        Lanjutkan mapping untuk menghubungkan kode produk di toko-mu dengan barcode produk Paragon.
                    </Text>
                </Flex>
            ) : count_success === 0 ? (
                <Flex alignItems={'center'} flexDir={'column'} gap={'16px'} textAlign={'center'} my={'32px'}>
                    <Text color={'warning.600'} fontWeight={'700'} fontSize={'18px'} maxW={'430px'}>
                        Tidak Ada Produk untuk Dihubungkan
                    </Text>
                    <Text fontSize={'14px'} maxW={'430px'}>
                        Periksa dan upload kembali data produk yang ingin kamu hubungkan dengan barcode produk Paragon.
                    </Text>
                </Flex>
            ) : (
                <Flex alignItems={'center'} flexDir={'column'} gap={'16px'} textAlign={'center'} my={'32px'}>
                    <Text color={'success.600'} fontWeight={'700'} fontSize={'18px'} maxW={'430px'}>
                        Semua Produk Sesuai dengan Barcode Paragon
                    </Text>
                    <Text fontSize={'14px'} maxW={'430px'}>
                        Data produk yang kamu upload sesuai atau berhasil terhubung dengan barcode produk Paragon.
                    </Text>
                </Flex>
            )}

            {count_success === 0 && count_failed === 0 ? (
                <Flex justifyContent={'center'} gap={'12px'}>
                    <Button onClick={handleClose} isDisabled={isLoading} px={'42px'}>
                        Tutup
                    </Button>
                </Flex>
            ) : (
                <Flex justifyContent={'center'} gap={'12px'}>
                    <Button variant={'outline'} onClick={handleCancel}>
                        {count_failed > 0 ? 'Batalkan Mapping' : 'Batalkan'}
                    </Button>
                    <Button onClick={handleContinue} isDisabled={isLoading}>
                        {isLoading ? (
                            <Spinner m={10} />
                        ) : count_failed > 0 ? (
                            'Lanjutkan Mapping'
                        ) : (
                            `Upload ${count_success} Produk`
                        )}
                    </Button>
                </Flex>
            )}
        </Box>
    );
}
